import { extend, setInteractionMode } from "vee-validate";
import BadWordsFilter from "./bad-words-filter";

setInteractionMode("lazy");

const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
const alphaRegex = /[0-9]+/g;

extend("required", {
  computesRequired: true,
  validate(value) {
    const valid = ["", null, undefined].indexOf(value) === -1;
    // console.log(`Validating ${value}: ${valid ? "valid" : "invalid"}`);
    return {
      required: true,
      valid,
    };
  },
  message: "{_field_} is required",
});

extend("clean", {
  validate(value) {
    if (BadWordsFilter.isProfane(value)) {
      return `'${value}' is not an acceptable name`;
    } else {
      return true;
    }
  },
});

extend("no-emoji", {
  validate(value) {
    const valid = !emojiRegex.test(value);

    if (valid) {
      return true;
    } else {
      return `Emojis aren't valid characters`;
    }
  },
});

extend("alpha-only", {
  validate(value) {
    const valid = !alphaRegex.test(value);

    if (valid) {
      return true;
    } else {
      return `Numbers aren't valid characters`;
    }
  },
});
